<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
     <div class="save-panel">
      <button class="btn btn-sm btn-success btn-icon mt-4" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "../../plugins/functions";

import FieldsList from "./FieldsList";
export default {
  name: "header",
  props: ["metatable_type", "metatable_id"],
  async created() {
    if (this.metatable_type && this.metatable_id) {
      this.item = await this.cardContent(this.cardLink, this.id, "single", {
        metatable_type: this.metatable_type,
        metatable_id: this.metatable_id,
      });

      this.item["metatable_type"] = this.metatable_type;
      this.item["metatable_id"] = this.metatable_id;
    }
  },
  data: () => ({
    cardLink: "seo",
    cardSetLink: "seo/update",
    item: {},
    fields: [
      {
        col: "col-md-6 col-12",
        key: "title",
        label: "Title",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
      {
        col: "col-md-6 col-12",
        key: "meta_title",
        label: "Meta Title",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },

      {
        key: "meta_keywords",
        label: "Meta Keywords",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
      {
        key: "meta_description",
        label: "Meta Description",
        type: "textarea",
        isMultiLang: true,
      },
      {
        key: "image",
        label: "Ссылка на изображение",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
    ],
  }),
  components: {
    FieldsList,
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    updateItem() {
      this.cardUpdate(this.cardSetLink, this.item);
    },
  },
};
</script>
<style>
</style>
